var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-pop-over-config-base", {
        attrs: { model: _vm.baseModel, configs: _vm.noConfigs },
        scopedSlots: _vm._u([
          {
            key: "notice",
            fn: function () {
              return [
                _c("sys-notice-config-moved", {
                  attrs: { card: "Integração Totvs" },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }